import fp from 'lodash/fp';
import { createActions } from 'redux-actions';
import { put, select } from 'redux-saga/effects';
import { apiActions as commonApiActions, apiResourceActionCreator, endpointQuery } from "../../common";
import { authTokenSelector } from '../../session';
import { API_ENDPOINT } from './endpoints';

const action = createActions({
  CPD_POINTS: {
    LOAD_MORE: (query) => ({ query }),
    API: {
      LOAD_MORE: apiResourceActionCreator('cpdPoints')
    }
  }
})

export const apiAction = (authToken, query) => commonApiActions.authenticated.get(`${API_ENDPOINT}${endpointQuery({ ...(query || {}) })}`, authToken, action.cpdPoints.api.loadMore)

function* loadMore(action) {
  const authToken = yield select(authTokenSelector);
  yield put(apiAction(authToken, action.payload.query));
}

const configuration = {
  name: 'loadMore',
  action: action,
  sagas: loadMore,
  reducers: {
    request: (state, action) => ({
      ...state,
      isFetching: true
    }),
    success: (state, action) => ({
      ...state,
      isFetching: false,
      cpdPoints: fp.concat(state.cpdPoints, action.payload.cpdPoints.userCpdPoints),
      totalCpdActivityCount: action.payload.cpdPoints.total,
      filterHits: action.payload.cpdPoints.hits
    }),
    failed: (state, action) => ({
      ...state,
      isFetching: false,
      error: action.payload.error
    })
  }
}

export default configuration;


// WEBPACK FOOTER //
// ./src/state/modules/cpd-points/configurations/loadMore.js